const NODE_ENV = process.env.REACT_APP_NODE_ENV;

export const IS_DEVELOPMENT = NODE_ENV === 'development';

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;